import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DateService } from 'src/app/services/date.service';
import { GeneralService } from 'src/app/services/general.service';
import { blobToBase64String, base64StringToBlob } from 'blob-util';
import { ListeComponent } from 'src/app/liste/liste.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { AvtDialogDeleteComponent } from 'src/app/avt-dialog-delete/avt-dialog-delete.component';
import { RechercheComponent } from 'src/app/recherche/recherche.component';

@Component({
  selector: 'app-grh-fiche',
  templateUrl: './grh-fiche.component.html',
  styleUrls: ['./grh-fiche.component.scss'],
})
export class GrhFicheComponent implements OnInit {
  constructor(
    public route: ActivatedRoute,
    private dateService: DateService,
    public generalService: GeneralService
  ) {}
  exist: boolean = false;
  selectedAnnee;
  selectedMois;
  fenetre: string;
  titre: string;
  listeAnnee = [];
  listeDocument = [];
  typeDocument = '';
  columns = {
    TableRD: [
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Date',
        Lg_Code: '',
        TableRD_Des: 'Date',
        TableRD_Largeur: 120,
        TableRD_ReadOnly: true,
        TableRD_Format: 'dd/MM/yyyy',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 4,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Text',
        Lg_Code: '',
        TableRD_Des: 'Libellé',
        TableRD_Largeur: 300,
        TableRD_ReadOnly: false,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
      {
        TableRE_Code: '',
        TableRD_Champs: 'File_Class',
        Lg_Code: '',
        TableRD_Des: 'Taille',
        TableRD_Largeur: 100,
        TableRD_ReadOnly: true,
        TableRD_Format: '',
        TableRD_Alligement: 0,
        TableRD_Ordre: 0,
        TableRD_Type: 0,
        TableRD_Param1: null,
        TableRD_Param2: null,
        TableRD_ValDef: null,
        TableRD_Tri: true,
        TableRD_Valid: null,
        TableRD_ValidType: 0,
        TableRD_ExpressionH: null,
        TableRD_ExpressionR: null,
        User_Id: '*',
        User_Groupe: null,
      },
    ],
  };
  monthsTab = this.dateService.monthsTab;
  @ViewChild('listeFicheConmponent', { static: false })
  listeFicheConmponent: ListeComponent;
  @ViewChild('collaborateurComponent', { static: false })
  collaborateurComponent: RechercheComponent;
  ngOnInit(): void {
    var annee = new Date().getFullYear();
    this.selectedMois = new Date().getMonth();
    this.selectedAnnee = annee;
    for (var i = 0; i < 10; i++) {
      this.listeAnnee.push(annee);
      annee--;
    }
    this.readParamUrl();
  }
  init() {
    if (this.fenetre == '1') {
      this.typeDocument = 'FICHEDEPAIES';
      this.titre = 'FICHE DE PAIES';
    }
    if (this.fenetre == '0') {
      this.titre = 'MES CONTRATS';
      this.typeDocument = 'CONTRAT';
    }
    if (this.fenetre == '2') {
      this.titre = 'FICHE DE PAIES PAR COLLABORATEUR';
      this.typeDocument = 'FICHEDEPAIES';
    }
    if (this.fenetre == '3') {
      this.titre = 'MES CONTRATS PAR COLLABORATEUR';
      this.typeDocument = 'CONTRAT';
    }

    if (this.fenetre == '4') {
      this.titre = 'MUTUELLE ET PRÉVOYANCE';
      this.typeDocument = 'MUTUELLE';
    }
    if (this.fenetre == '5') {
      this.titre = 'LIVRET ACCUEIL';
      this.typeDocument = 'LIVRET';
    }
    this.getListeFiles();
  }
  getListeFiles() {
    this.exist = false;
    var url;
    if (
      this.fenetre == '1' ||
      this.fenetre == '0' ||
      this.fenetre == '4' ||
      this.fenetre == '5'
    )
      if (this.generalService.collaborateurConnecter)
        url =
          this.generalService.url +
          'avtFileG&param=' +
          this.generalService.collaborateurConnecter +
          ',' +
          this.typeDocument +
          ',' +
          this.selectedAnnee +
          ',' +
          this.selectedMois;
      else
        setTimeout(() => {
          this.getListeFiles();
        }, 100);
    else if (this.fenetre == '2' || this.fenetre == '3')
      if (
        this.collaborateurComponent &&
        this.collaborateurComponent.valueColonneToReturn
      )
        url =
          this.generalService.url +
          'avtFileG&param=' +
          this.collaborateurComponent.valueColonneToReturn +
          ',' +
          this.typeDocument +
          ',' +
          this.selectedAnnee +
          ',' +
          this.selectedMois;
    if (url)
      this.generalService.rechercheTable(url).subscribe((data) => {
        this.listeFicheConmponent.row = null;
        this.listeDocument = data;
        this.exist = true;
      });
    else if (this.fenetre == '2' || this.fenetre == '3') this.exist = true;
  }
  getUrl() {}
  selectFile() {
    if (
      ((this.fenetre == '1' ||
        this.fenetre == '0' ||
        this.fenetre == '4' ||
        this.fenetre == '5') &&
        this.generalService.isNotEmpty(
          this.generalService.collaborateurConnecter
        )) ||
      ((this.fenetre == '2' || this.fenetre == '3') &&
        this.collaborateurComponent.valueColonneToReturn)
    )
      if (this.selectedAnnee && this.selectedMois)
        document.getElementById('file').click();
      else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une année et un mois',
          false
        );
  }
  supprimerFile() {
    if (this.listeFicheConmponent.row) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        AvtDialogDeleteComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'supprimer') {
          var deleteFn = this.generalService.supprimerSanMsgConfirm(
            this.listeFicheConmponent.row.File_Id,
            'avtFiles'
          );
          if (deleteFn != null) {
            this.exist = false;
            deleteFn.subscribe((data) => {
              this.listeFicheConmponent.row = null;
              this.generalService.dialogSuccess('Elément supprimer', true);
              this.getListeFiles();
            });
          }
        }
      });
    }
  }
  telechargerFile() {
    if (this.listeFicheConmponent.row) {
      this.exist = false;
      this.generalService
        .rechercheTable(
          this.generalService.urlFiles +
            '&val=' +
            this.listeFicheConmponent.row.File_Id
        )
        .subscribe((data) => {
          const b64Data = data;
          const blob = base64StringToBlob(b64Data.Files[0].File_Content);
          var fileURL = URL.createObjectURL(blob);
          window.URL.revokeObjectURL(fileURL);
          if (typeof window.navigator.msSaveBlob !== 'undefined') {
            window.navigator.msSaveBlob(
              blob,
              this.listeFicheConmponent.row.File_Text
            );
            return;
          }
          const blobURL = window.URL.createObjectURL(blob);
          const tempLink = document.createElement('a');
          tempLink.style.display = 'none';
          tempLink.href = blobURL;
          tempLink.setAttribute(
            'download',
            this.listeFicheConmponent.row.File_Text
          );
          if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank');
          }
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          setTimeout(() => {
            window.URL.revokeObjectURL(blobURL);
            this.exist = true;
          }, 100);
        });
    } else
      this.generalService.dialogSuccess(
        'Veuillez sélectionner un fichier',
        false
      );
  }
  onChangefile(fileInput) {
    var reader2 = new FileReader();
    var src: string;
    reader2.onload = (e) => {
      src = reader2.result.toString();
      var imageName = fileInput.target.files[0].name;
      var imageType = src.substring(0, src.indexOf(',') + 1);
      var imageSrc = src.replace(imageType, '');
      var coll;
      if (
        this.fenetre == '1' ||
        this.fenetre == '0' ||
        this.fenetre == '4' ||
        this.fenetre == '5'
      )
        coll = this.generalService.collaborateurConnecter;
      else if (this.fenetre == '2' || this.fenetre == '3')
        coll = this.collaborateurComponent.valueColonneToReturn;

      this.addFiles(
        this.generalService.initDoc,
        imageSrc,
        imageName,
        coll,
        this.typeDocument,
        this.selectedAnnee,
        this.selectedMois,
        fileInput.target.files[0].size
      );
    };
    reader2.readAsDataURL(fileInput.target.files[0]);
  }

  addFiles(
    initDoc,
    File_Content,
    File_Text,
    File_Key,
    File_Type,
    File_Lien,
    File_Autre,
    File_Class
  ) {
    this.exist = false;
    var doc = initDoc;
    doc.files[0].File_Content = File_Content;
    doc.files[0].File_Text = File_Text;
    doc.files[0].File_Key = File_Key;
    doc.files[0].File_Type = File_Type;
    doc.files[0].File_Lien = File_Lien;
    doc.files[0].File_Autre = File_Autre;
    //File_Class : taille de fichier
    if (File_Class / 1000000 >= 1)
      File_Class = (File_Class / 1000000).toFixed(3) + ' Mo';
    else if (File_Class / 1000 >= 1)
      File_Class = (File_Class / 1000).toFixed(3) + ' ko';
    else File_Class += ' octet';
    doc.files[0].File_Class = File_Class;
    this.exist = false;
    this.generalService.enregisterTable(doc).subscribe((data) => {
      this.generalService.dialogSuccess('Document enregistré', true);
      this.getListeFiles();
    });
  }
  readParamUrl() {
    this.route.params.subscribe((params) => {
      this.fenetre = params['fenetre'];
      this.init();
    });
  }
}
